const jobsData = [
    {
        id: "information-security-manager-3",

        title: "INFORMATION SECURITY MANAGER 3",

        date: "05 JAN 2025",
        location: "AUSTIN, TEXAS, USA",

        type: "FULL-TIME",

        shortDesc:
            "MANAGE A COMPLEX WEB APPLICATION FIREWALL PROJECT AND OVERSEE SECURITY OPERATIONS.",

        description: `THIS IS MANAGER III POSITION WILL MANAGE A COMPLEX WEB APPLICATION FIREWALL PROJECT. THE PROJECT REQUIRES ADVANCED SECURITY PROJECT MANAGEMENT EXPERIENCE AND EXTENSIVE KNOWLEDGE OF WEB INFORMATION SYSTEMS, INFORMATION SYSTEMS CONTROLS, AND WEB APPLICATION DEVELOPMENT.

THE PROJECT INVOLVES MANAGING STAFF INCLUDING AN APPLICATION/SOFTWARE DEVELOPER AND TWO NETWORK SECURITY ANALYSTS. THE MANAGER MAY NEED TO INDEPENDENTLY PERFORM COMPLEX IT TASKS WHEN RESOURCES ARE LIMITED.

THE INFORMATION SECURITY MANAGER WILL MANAGE PROJECT BUDGETS AND TIMELINES USING ENTERPRISE PORTFOLIO PROJECT MANAGEMENT SOFTWARE AND COORDINATE WITH MANAGED SERVICE VENDORS.

THE POSITION MUST FOLLOW DIR PROJECT MANAGEMENT FRAMEWORK AND ENSURE COMPLIANCE WITH HEALTH AND HUMAN SERVICES AND DSHS SECURITY STANDARDS.`,

        responsibilities: [

            "MANAGE A COMPLEX WEB APPLICATION FIREWALL PROJECT",

            "MANAGE APPLICATION DEVELOPER AND NETWORK SECURITY ANALYSTS",

            "HANDLE PROJECT BUDGET AND TIMELINES",

            "COORDINATE WITH MANAGED SERVICES VENDOR",

            "ENSURE PROJECT IMPLEMENTATION ON TIME AND WITHIN SCOPE",

            "FOLLOW DIR PROJECT MANAGEMENT FRAMEWORK",

            "ENSURE COMPLIANCE WITH DSHS IT STANDARDS",

            "PERFORM COMPLEX IT TASKS WHEN RESOURCES ARE LIMITED"

        ],

        requirements: [

            "10+ YEARS ADVANCED SECURITY PROJECT MANAGEMENT EXPERIENCE",

            "8+ YEARS MANAGING LARGE-SCALE FIREWALL PROJECTS",

            "8+ YEARS MANAGING SECURITY TEAMS",

            "8+ YEARS PROJECT BUDGET AND TIMELINE MANAGEMENT",

            "STRONG KNOWLEDGE OF DIR PROJECT MANAGEMENT FRAMEWORK"

        ],

        preferred: [

            "EXPERIENCE DESIGNING AND SECURING WEB INFORMATION SYSTEMS",

            "EXPERIENCE WITH WAF SAAS APPLICATIONS",

            "ABILITY TO WORK INDEPENDENTLY",

            "EXPERIENCE WORKING WITH HHSC SECURITY TEAMS"

        ],

        onsite:

            "100% ONSITE WORK INCLUDING IN-PERSON INTERVIEWS",

        address:

            "701 WEST 51ST, AUSTIN, TEXAS 78751",

        notes:

            "CANDIDATES MUST RESIDE IN TEXAS. NO OUT-OF-STATE CANDIDATES."

    },
    {
        id: "business-analyst-3",

        title: "BUSINESS ANALYST 3",

        date: "05 JAN 2025",

        location: "TEXAS, USA",

        type: "FULL-TIME",

        shortDesc:
            "GATHER, ANALYZE, AND DOCUMENT BUSINESS REQUIREMENTS AND IMPROVE SYSTEMS USING AGILE METHODOLOGIES.",

        description:
            "THE BUSINESS ANALYST WILL GATHER, ANALYZE, AND DOCUMENT USER REQUIREMENTS, BUSINESS PROCESSES, AND PROBLEMS TO AUTOMATE OR IMPROVE EXISTING SYSTEMS. THE ROLE INCLUDES LEADING AGILE AND SCRUM SDLC PROCESSES, FACILITATING MEETINGS AND TRAINING SESSIONS, AND ENSURING PROPER DOCUMENTATION AND SYSTEM IMPROVEMENTS.",

        responsibilities: [

            "GATHER, ANALYZE, AND DOCUMENT USER REQUIREMENTS AND BUSINESS PROCESSES",

            "LEAD APPLICATION CHANGE SDLC USING AGILE AND SCRUM METHODOLOGIES",

            "MAINTAIN CHANGE MANAGEMENT DOCUMENTATION",

            "FACILITATE MEETINGS AND TRAINING SESSIONS",

            "ANALYZE PROGRAM POLICIES AND PROCEDURES AFFECTING AUTOMATED SYSTEMS",

            "MAINTAIN REQUIREMENTS REPOSITORY",

            "RECOMMEND PROCESS IMPROVEMENTS THROUGH AUTOMATION",

            "DEVELOP PROJECT CHARTERS, PLANS, AND RISK MANAGEMENT DELIVERABLES",

            "TROUBLESHOOT SYSTEM PROBLEMS AND RECOMMEND SOLUTIONS",

            "PROVIDE QUALITY ASSURANCE CONSULTATION",

            "DEVELOP AND REVIEW TEST CASES",

            "MANAGE PROJECT SCOPE AND DEPLOYMENT",

            "MAINTAIN VENDOR RELATIONSHIPS AND REVIEW INVOICES",

            "FOLLOW TDA POLICIES AND PROCEDURES"

        ],

        requirements: [

            "8+ YEARS PERFORMING SENIOR-LEVEL BUSINESS ANALYSIS WORK",

            "8+ YEARS DEVELOPING PROJECT DELIVERABLES AND DOCUMENTATION",

            "6+ YEARS ANALYZING APPLICATIONS AND TROUBLESHOOTING SYSTEMS",

            "6+ YEARS PROVIDING QUALITY ASSURANCE CONSULTATION",

            "6+ YEARS LEADING AGILE AND SCRUM SDLC PROJECTS",

            "5+ YEARS IMPROVING BUSINESS PROCESSES THROUGH AUTOMATION",

            "5+ YEARS DEVELOPING TRAINING CURRICULA",

            "5+ YEARS DEVELOPING TEST CASES AND PROCESSING CHANGE REQUESTS",

            "3+ YEARS COMMUNICATING WITH EXECUTIVE LEADERSHIP"

        ],

        preferred: [

            "PRIOR STATE OR FEDERAL GOVERNMENT WORK EXPERIENCE",

            "CSM CERTIFICATION",

            "ITIL CERTIFICATION"

        ]
    }
];

export default jobsData;